<ui-confirmation-dialog
    header="change-requests.submitRequestTitle"
    primaryButtonLabel="submit"
    secondaryButtonLabel="cancel"
    #confirmRequestSubmission
>
    <div *ngIf="isConfirming" class="margin-bottom-2">
        <p>{{ 'change-requests.submitRequestInstruction' | translate }}</p>

        <div class="margin-top-3 margin-bottom-3 margin-left-2">
            <div class="app-grid margin-bottom-2 labels">
                <div class="columns-4"></div>
                <div class="columns-3">{{ 'change-requests.current' | translate }}</div>
                <div class="columns-1"></div>
                <div class="columns-3">{{ 'change-requests.updated' | translate }}</div>
            </div>
            <div *ngFor="let item of changedFieldValues | keyvalue" class="app-grid align-items-top margin-bottom-1">
                <span class="columns-4 font-medium">{{
                    templateFieldsByKey.get(item.key).name | appTranslateOptions: changeRequestTemplateFieldOptions
                }}</span>
                <span class="columns-3">
                    <field-value-display-component
                        [value]="item.value.oldValue"
                        [fieldKey]="item.key"
                    ></field-value-display-component>
                </span>
                <div class="columns-1"><mat-icon class="margin-right-1" svgIcon="arrowRight"></mat-icon></div>
                <span class="columns-3">
                    <field-value-display-component
                        *ngIf="item.value.newValue"
                        [value]="item.value.newValue"
                        [fieldKey]="item.key"
                    ></field-value-display-component>

                    <span *ngIf="!item.value.newValue" class="field-value-removed">{{
                        'change-requests.removed' | translate
                    }}</span>
                </span>
            </div>
        </div>
    </div>

    <div>{{ 'change-requests.fieldUpdateInstruction' | translate }}</div>
</ui-confirmation-dialog>
<div class="ui basic segment" [class.loading]="isLoading">
    <app-header [title]="title" [back]="true"></app-header>

    <div class="app-grid">
        <div class="columns-8">
            <ui-card>
                <div class="template-description" *ngIf="changeRequestTemplate.description">
                    <h2>{{ 'change-requests.requestDescription' | translate }}</h2>
                    <p class="margin-bottom-0">{{ changeRequestTemplate.description }}</p>
                    <hr class="margin-top-3 margin-bottom-3" />
                </div>

                <h2>{{ 'change-requests.requestDetails' | translate }}</h2>

                <div *ngIf="fieldErrorMap.has('data.attributes')">
                    <span class="validation-error-message">{{ fieldErrorMap.get('data.attributes') }}</span>
                </div>

                <form #form="ngForm" autocomplete="off">
                    <div class="app-grid margin-top-4 margin-bottom-2">
                        <div class="columns-3"></div>
                        <div class="columns-3 column-heading">{{ 'change-requests.currentValue' | translate }}</div>
                        <div class="columns-1"></div>
                        <div class="columns-1 flex justify-center column-heading">
                            {{ 'change-requests.update' | translate }}
                        </div>
                        <div class="columns-3 column-heading">{{ 'change-requests.updatedValue' | translate }}</div>
                    </div>

                    <div
                        class="app-grid field-row"
                        *ngFor="let field of changeRequestTemplate.changeRequestTemplateFields"
                    >
                        <div class="columns-3 row-heading aligned-cell padding-left-2">
                            {{ field.name | appTranslateOptions: changeRequestTemplateFieldOptions }}
                        </div>
                        <div class="columns-3 aligned-cell">
                            <field-value-display-component
                                *ngIf="!isLoading"
                                [value]="employeeValues[field.key]"
                                [fieldKey]="field.key"
                            ></field-value-display-component>
                        </div>
                        <div class="columns-1 aligned-cell">
                            <mat-icon class="margin-right-1" svgIcon="arrowRight"></mat-icon>
                        </div>
                        <div class="columns-1 flex justify-center align-items-top aligned-cell">
                            <mat-checkbox
                                aria-label="{{ field.name }} {{ 'change-requests.update' | translate }}"
                                name="{{ field.key }}-updated"
                                (change)="handleUpdateCheckboxChange(field.key, $event.checked)"
                            ></mat-checkbox>
                        </div>
                        <field-value-input-component
                            class="columns-3"
                            *ngIf="!isLoading"
                            [disabled]="!updatedFieldsMap.has(field.key)"
                            [value]="employeeValues[field.key]"
                            [initialValue]="employeeValues[field.key]"
                            [fieldKey]="field.key"
                            [errorMessage]="fieldErrorMap.get(field.key)"
                            (valueUpdated)="handleFieldValueChange(field.key, $event)"
                            aria-label="{{ field.name }} {{ 'change-requests.updatedValue' | translate }}"
                        ></field-value-input-component>
                    </div>

                    <h3 id="effective-date-label">{{ 'change-requests.effectiveDate' | translate }}</h3>
                    <mat-form-field class="no-labels no-helpers">
                        <mat-label class="sr-only">{{ 'change-requests.effectiveDate' | translate }}</mat-label>
                        <input
                            matInput
                            [matDatepicker]="picker"
                            [(ngModel)]="effectiveDate"
                            readonly
                            name="effective_at"
                            aria-labelledby="effective-date-label"
                        />
                        <mat-datepicker-toggle
                            matSuffix
                            [for]="picker"
                            aria-label="{{ 'change-requests.effectiveDate' | translate }} {{
                                'screen-reader-only.openCalendar' | translate
                            }}"
                        />
                        <mat-datepicker #picker />
                    </mat-form-field>
                </form>
            </ui-card>

            <div class="flex justify-end">
                <ui-button
                    type="primary"
                    [disabled]="!effectiveDate || updatedFieldsMap.size === 0 || changedFieldValues.size === 0"
                    (click)="onSave()"
                    >{{ 'submit' | translate }}</ui-button
                >
            </div>
        </div>
        <div class="columns-4">
            <change-request-approval-preview
                *ngIf="changeRequestTemplate"
                [changeRequestTemplate]="changeRequestTemplate"
                [effectiveAtDate]="effectiveDate"
                [subject]="employee"
            ></change-request-approval-preview>
        </div>
    </div>
</div>
